import { Button } from "antd";
import { ReactNode } from "react";

type Props = {
  loading?: boolean;
  file?: string;
  closeIcon?: ReactNode;
};

export default function FileDragAndDrop({ loading, file, closeIcon }: Props) {
  return (
    <>
      {!file && (
        <button
          className="h-32 p-3.5 bg-white rounded-md outline outline-1 outline-offset-[-1px] outline-zinc-200 overflow-hidden flex flex-col items-center justify-center cursor-pointer w-full disabled:cursor-not-allowed"
          disabled={loading}
          type="button"
        >
          {loading ? (
            <span className="text-[#3D4A5C] text-sm font-medium inline-block">
              Uploading...
            </span>
          ) : (
            <div className="text-center">
              <span className="text-display-dark text-sm font-normal leading-normal">
                Drag and Drop
                <br />
                Or
                <br />
              </span>
              <span className="text-[#3D4A5C] text-sm font-medium underline leading-normal mt-[1px]">
                Upload File
              </span>
            </div>
          )}
        </button>
      )}
      {file ? (
        <>
          <div className="h-56 relative">
            <img className="w-full h-full rounded-lg" src={file} alt="" />
            <div className="absolute right-0 -bottom-12">
              <Button
                size="middle"
                className="!px-3 text-primary border-primary !font-semibold"
                loading={loading}
              >
                Update Image
              </Button>
            </div>
          </div>
        </>
      ) : null}
      {/* {file && (
        <div className="text-[#3D4A5C] text-sm font-medium flex items-center gap-2 mt-0.5">
          <span
            className="flex-1 overflow-hidden whitespace-nowrap text-ellipsis"
            title={file}
          >
            {file}
          </span>
          {closeIcon}
        </div>
      )} */}
    </>
  );
}
